<template>
    <div class="diagramCont">
        <div class="diagram" v-for="item in options">
            <div class="content row-center" style="justify-content:flex-start">
                <div class="row-center">
                    <el-date-picker
                            :editable="false"
                            :picker-options="pickerOptions"
                            :clearable="false"
                            class="dateSelect"
                            v-model="date"
                            type="date"
                            :placeholder="new Date().toLocaleDateString().replace(/\//g, '-')"
                    >
                    </el-date-picker>
                    <el-select
                            style="width: 120px !important"
                            class="node-select"
                            v-model="item.value"
                            placeholder="请选择"
                            disabled
                    >
                        <el-option
                            v-for="i in options"
                            :key="i.value"
                            :value="i.value"
                            :label="i.label"
                        >
                        </el-option>
                    </el-select>
                    <el-button
                            class="btn per"
                            plain
                            @click="perD">上一日</el-button>
                    <el-button
                            class="btn next"
                            plain
                            @click="nextD"
                            :disabled="nextDayDisabled"
                    >下一日
                    </el-button
                    >
                </div>
                <div class="row-center">
                    <div class="max">
                        <el-checkbox
                                label="最值分析"
                                name="type"
                                v-model="showMax"
                        >
                        </el-checkbox>
                    </div>
                    
                </div>
            </div>
            <Chart :showMax="showMax" :diagramData="item.diagramData" :canvasData="item.canvasData" :devicetype="devicetype" ></Chart>
        </div>
    </div>
</template>

<script>
    
    import {
        harmonicAnalysis,LOOP_DIAGRAM_DATA_BY_DAY,getLoadCharts
    } from "../../../api/power";
	import {floatFormat} from "../../../util/MathUtil";
    import { subscribe } from '../../../mqtt/index'
	import Chart from "./Chart.vue";
    import {
		dateFormat,
		dayEnd,
		dayStart,
		nextDay,
		nextMonth,
		nextYear,
		perDay,
		perMonth,
		perYear,
	} from "../../../util/DateUtil";
    export default {
        name: "Harmonic",
        components: {
            Chart
        },
        props:{
            currentLoop:Object,
            devicetype:Number,
            device_category_id:Number
        },
        data() {
            return {
                pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
				date: new Date(),
                node: "0-1",
                showMax:true,
                diagramData: null,
                canvasData:false,
                options:[
                    {
                        value: '0-1',
                        label: '三相电流',
                        diagramData: null,
                        canvasData:false,
                    },
                    {
                        value: '0-0',
                        label: '三相线电压',
                        diagramData: null,
                        canvasData:false,
                    },
                ],
            }
        },
        computed:{
            realData() {
                return [{
                        details: [
                            {
                                key: "三相线电压",
                                unit: this.device_category_id==1?"kV":"V",
                                data: {
                                    A: "Uab",
                                    B: "Ubc",
                                    C: "Uac",
                                }
                            },

                            {
                                key: "三相电流",
                                unit: "A",
                                data: {
                                    'A': "Ia",
                                    'B': "Ib",
                                    'C': "Ic",
                                }
                            },
                        ]
                        }]
            },
			mqttval() {
				return this.getMqttVal(this.$store.getters.mqttVal);
			},
            nextDayDisabled() {
				let timestamp = dateFormat("YY-mm-dd", new Date());
				let endtime = dateFormat("YY-mm-dd", this.date);
				if (this.radio === "year") {
					timestamp = dateFormat("YY", new Date());
					endtime = dateFormat("YY", this.date);
				} else if (this.radio === "month") {
					timestamp = dateFormat("YY-mm", new Date());
					endtime = dateFormat("YY-mm", this.date);
				}
				if (endtime >= timestamp) {
					return true;
				} else {
					return false;
				}
			},
            updataData(){
                return [
                    this.currentLoop,this.date,this.showMax
                ]
            },
            //select选择的label
            selectLabel() {
                return (val)=>this.options.filter((item) => item.value === val)[0].label;
            },
        },
        watch:{
            updataData(){
                this.options.forEach((item,index)=>{
                    this.canvasDataRult(item,index)
                })
            }
        },
        mounted(){
            this.options.forEach((item,index)=>{
                this.canvasDataRult(item,index)
            })
            
        },
        methods: {
            canvasDataRult(item,index) {
				let strings = item.value.split("-");
                let data = this.realData[strings[0]].details[strings[1]].data;
                let unit = this.realData[strings[0]].details[strings[1]].unit;
                let multiple = this.realData[strings[0]].details[strings[1]].multiple
                let loopId = this.currentLoop.loopId;
                if(this.$store.getters.projectId==5){//高压模拟数据
                    if(this.currentLoop.loopType=='GTI'||this.currentLoop.loopType=='GTO'){ 
                        loopId = 1265
                    }
                }
                let promises = [];
                let legendTitle = [];
                for (let key in data) {
                    if (data.hasOwnProperty(key)) {
                        let node = data[key];
                        if (node) {
                            if (this.selectLabel(item.value) == '三相电流') {
                                legendTitle.push(key + '相电流')
                            } else if (this.selectLabel(item.value) == '三相相电压') {
                                legendTitle.push(key + '相相电压')
                            } else if (this.selectLabel(item.value) == '三相线电压') {
                                legendTitle.push(key + '相线电压')
                            } else {
                                legendTitle.push(key === "总" ? key + this.selectLabel(item.value) : key + '相' + this.selectLabel(item.value))
                            }
                            let start = dayStart(this.date)
                            let end = dayEnd(this.date)
                            let obj = {
                                deviceLoopId:loopId,
                                start:start,
                                end:end,
                                group:"5m",
                                node:node
                            }
                            promises.push(
                                // LOOP_DIAGRAM_DATA_BY_DAY(
                                //     loopId,
                                //     node,
                                //     this.date
                                // )
                                getLoadCharts(obj)
                            );
                        }
                    }
                }
                Promise.all(promises).then((res) => {
                    let pointsArray = []
                    let map = res.map((r) => (r.data ? r.data.data.points : []));
                    for (let key in data) {
                        if (data.hasOwnProperty(key)) {
                            let node = data[key];
                            map.forEach(item=>{
                                if(item[node]){
                                    pointsArray.push(item[node])
                                }
                            })
                        }
                    }
                    let list = [];
                    pointsArray.forEach((e) => {
                        list = list.concat(e);
                    });
                    if(list.length==0){
                        this.options[index].canvasData = true
                    }else{
                        this.options[index].canvasData = false
                    }

                    let obj = {};
                    let xAxisData = [];
                    let seriesData = [];
                    for (let index = 0; index < pointsArray[0].length; index++) {
                        const e = pointsArray[0][index];
                        if (e.val!='') {
                            xAxisData.push(e.time.split('T')[1].substr(0, 5));
                        }
                    }
                    pointsArray.forEach((e, i) => {
                        seriesData.push({
                            name: legendTitle[i],
                            data: e.map((p) => {
                                let v = p.val;
                                if(v!=""){
                                    if (multiple) {
                                        v *= multiple
                                    }
                                    return Number(v).toFixed(2)
                                }else{
                                    return ""
                                }
                                
                            }).filter(e=>e!='')
                        });
                    });
                    this.options[index].diagramData = this.createCanvasData(legendTitle, xAxisData, seriesData,unit)
                    // this.$set(
                    //     this,
                    //     "diagramData",
                    //     this.createCanvasData(legendTitle, xAxisData, seriesData)
                    // );
                });
                return true;
			},
            
            createCanvasData(legendData, xAxisData, seriesData,unit) {
                
                let series;
                let markPoint = {};
				if (this.showMax) {
					//最值分析加标点
					markPoint = {
						data: [
							{
								type: "max",
								name: "最大值",
							},
							{
								type: "min",
								name: "最小值",
							},
						],

						symbol: "pin",
						symbolSize: "20",
						label: {
							position: "top",
						},
					};
				}
                series = seriesData.map((e) => {
                    return {
                        smooth: true,
                        name: e.name,
                        step: 'start',
                        symbol:'none',
                        type: "line",
                        data: e.data,
                        connectNulls: true,
                        markPoint
                    };
                });
                let color = ["#F6BD16", "#5AD8A6", "#E8684A", "#5D7092"];

                return {
                    color,
                    tooltip: {
                        trigger: "axis",
                        textStyle: {
                            color: "#333333" //设置文字颜色
                        },
                        formatter: function (params) {
                            let str = `${params[0].name}<br/>`;
                            params.forEach((item, idx) => {
                                str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.data}</b><b style='font-size:14px;'> ${unit}</b>`;
                                str += idx === params.length -1? '': '<br/>'
                            })
                            return str
                        }
                    },
                    legend: {
                        top: 0,
                        itemWidth: 10,
                        itemHeight: 10,
                        icon: "rect",
                        data: legendData,
                        textStyle: {
                            fontSize: "16rem"
                        },
                        itemGap: 20,
                        itemStyle: {

                        }
                    },
                    grid: {
                        left: 10,
                        right: "3%",
                        top:"10%",
                        bottom: "5%",
                        containLabel: true
                    },
                    toolbox: {
                        feature: {
                        },
                    },
                    xAxis: {
                        type: "category",
                        boundaryGap: false,
                        data: xAxisData,
                        splitLine: {
                            show: true
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#CCCCCC",
                                width: 1,
                                type: "solid",
                            },
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999",
                            },
                        },
                    },
                    yAxis:{
                        nameTextStyle: {
                            color: "#999999",
                            // fontSize: "14",
                        },
                        boundaryGap: true,
                        axisTick: {
                            show: false,
                        },
                        show: true,
                        spiltLine: {
                            show: true
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#CCCCCC",
                                width: 1,
                                type: "solid",
                            },
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999",
                            },
                        },
                        type: "value",
                        name:unit
                    },
                    series,
                };
            },
            getMqttVal(f) {
				return (k, m) => {
					if (k) {
						
						let mqttVal = f(k);
						if (m) {
							mqttVal *= m;
						}

						mqttVal = floatFormat(mqttVal, 2);

						// console.log(typeof mqttVal)

						if (typeof mqttVal === "object") {
							return mqttVal;
						}

						return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
					} else {
						return "--";
					}
				};
			},
            perD() {
				this.date = perDay(this.date);
			},
			nextD() {
				this.date = nextDay(this.date);
			},
        },
    };
</script>

<style lang="less" scoped> 
.diagram {
    margin-top: 15px;
    // .h(468);
    .content {
        // margin-top: 10rem;
        // border-bottom: 1px solid rgba(0, 0, 0, 0.15);
        padding-bottom: 10rem;
        .dateSelect {
            font-size: 18rem;
            color: #000000 !important;
            margin-right: 8rem;
        }
        .node-select{
            margin-right: 8rem;
        }

        .max {
            .w(100);
            margin-left: 27rem;
        }

        .hose {
            display: flex;
            align-items: center;
        }
    }

}
</style>